<app-navbar></app-navbar>
<section>
  <div class="container">
    <div class="row">
      <div class='card m-5'>
        <div class='card-body'>
          <div class="col-md-12">
            <h1 class="custom-title mt-3">Area Chief Patron's Message</h1>
            <div class="custom-image">
              <img src="assets/img/school/messages/1.jpg" alt="Image" class="img-fluid" style="max-width: 100%;">
            </div>
            <div class="custom-text mt-3">
              <p>Today's children are tomorrow's future. Proyash-Chattogram continues to work to bring children with
                special needs and
                adolescents into the mainstream of society through special education and activities. I believe that it
                reveals the
                inherent creativity of special needs children who, if given proper care, training, and education, can
                join the
                mainstream and contribute to the development of society and the country. I am proud of the service
                provided by
                Proyash-Chattogram to the children with special needs from all walks of life. Proyash-Chattogram
                organizes various
                social awareness programs for children and adolescents with disabilities, which conveys a positive
                message not only to
                the families of special needs children but also to society. Through sincere efforts and cooperation,
                special children
                can become self-reliant and stable in society. In a short span of time, Proyash-Chattogram had been able
                to prove itself
                as a modern, up-to-date, and important institution at the national level. My sincere congratulations and
                best wishes to
                those who are showing service-mindedness, prudence, and patience with immense sacrifice and hard work to
                make this
                far-reaching program worthwhile. I feel blessed to be the Area Chief Patron of such a noble
                organization.</p>
              <p>Jai Bangla, May Bangladesh live forever.</p>
              <br>
              <br>
              <p class="custom-bold">Major General Mohammad Shaheenul Haque, OSP, BSP, ndc, hdmc, psc</p>
              <p>General Officer Commanding 24 Infantry Division and</p>
              <p>Area Commander Chattogram Area</p>
              <p class="custom-bold">Area Chief Patron Proyash-Chattogram</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>